import { render, staticRenderFns } from "./send-stock-movement-modal.vue?vue&type=template&id=1cc1d636&"
import script from "./send-stock-movement-modal.vue?vue&type=script&lang=js&"
export * from "./send-stock-movement-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports